module.exports = "/_next/static/images/3558d313f2f695a4a1580e2a9956d9fa-hero-xs.jpg";